<template>
  <div id="search" :class="{'fixed':fixed}">
    <span class="logo">
      <img src="../../static/images/logo.png" alt="联盟logo" style="width:100px;height:100px" @click="toLogin">
    </span>
    <span class="search">
      <input v-model="searchText" type="text" placeholder="请输入商品名、生产厂家" @click="jump" @input="searchList" @keyup.enter="search">
      <ul v-if="words" class="search-list">
        <li v-for="(word,index) in words" :key="index" @click="searchByKeWords(word)">{{ word }}</li>
      </ul>
      <button @click="search">搜索</button>
    </span>
    <router-link to="/myCart">
      <span class="cart">
        <img src="../../static/images/cart.png" alt="购物车图标"><span class="cart-num">{{ cartNum }}</span>
      </span>
    </router-link>
  </div>
</template>
<script>
export default {
  props: {
    words: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      searchText: '',
      fixed: false
    }
  },
  computed: {
    cartNum: function () {
      var cartNum = this.$store.getters.cartNum
      if (cartNum >= 1000) cartNum = '999+'
      if (cartNum === 0) cartNum = ''
      return cartNum
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleNavbarFix, true)
  },
  methods: {
    toLogin () {
      window.location.href = 'http://www.lyly360.com/hy-mic-sy/login.html'
    },
    search () {
      this.$emit('search', this.searchText)
    },
    jump () {
      this.$router.push({ path: '/order' })
    },
    searchList () {
      if (this.searchText.trim().length >= 2) {
        this.$emit('searchList', this.searchText.trim())
      }
    },
    // handleNavbarFix () {
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   var offsetTop = document.querySelector('#search').offsetTop
    //   scrollTop > offsetTop ? this.fixed = true : this.fixed = false
    // },
    searchByKeWords (word) {
      this.$emit('searchByKeWords', word)
      this.searchText = word
    }
  }
  // beforeRouteLeave (to, from, next) {
  //   window.removeEventListener('scroll', this.handleNavbarFix, true)
  //   next()
  // }
}
</script>
<style>
#search{
  width: 100%
}
 li {
   list-style: none;
   line-height: 40px;
   cursor: pointer;
 }
  .logo{
  margin-top:20px;
  display: inline-block;
  margin-bottom: 20px;
  margin-left: 25px;
}
.search {
  position: relative;
}
.fixed {
  position:fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  border-bottom: 2px solid #ed1717;
  box-shadow: 0px 0px 0px 0px #fff;
  z-index: 100000;
}
.search button{
  position: relative;
  top: -1px;
  outline:0 none !important;
  border: 2px solid #ed1717;
  background-color: #ed1717;
  color: #ffffff;
  width: 90px;
  height: 37px;
}
.search button:active{
    box-shadow: .05em .1em .2em #ed1717 inset;
    border-color: #ed1717;
    background: #bbb;
}
.search input{
  outline:0 none !important;
  margin-left:330px;
  height: 38px;
  width: 458px;
  text-indent: 10px;
  border: solid 1px #e62129
}
.search .search-list {
  position: absolute;
  width: 458px;
  top: 29px;
  left: 330px;
  max-height: 240px;
  overflow-y: scroll;
  text-align: left;
  border: 1px solid #ccc;
  border-top: 0;
  padding-left: 10px;
  margin-bottom: 0;
  background-color: #fff;
  z-index: 10000;
}
.cart{
  position: relative;
  margin-left: 30px;
  width: 140px;
  height:36px;
}
.cart .cart-num {
  position: absolute;
  display: inline-block;
  width: 24px;
  max-height: 24px;
  left: 112px;
  top: 0;
  background-color: #f00;
  color: #fff;
  border-radius: 50%;
  font-size: 0.55rem;
}
</style>
